<template>
  <div id="app" :class="''+($store.state.needTop)">
    <topBar v-if="$store.state.needTop"></topBar>
    <router-view v-if="getDataOver && isRouterAlive" />
    <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size=36 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import {Base64} from 'js-base64'
// const Base64 = require('js-base64').Base64
export default {
  name: 'App',
  data() {
    return {
      getDataOver: false, // 数据是否获取完成
      getDataNum: 0, // 获取的数据个数
      isRouterAlive: true, //加载完判断是否需要重新刷新当前页面
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  created() {
    let _this = this
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    // 获取机构用户个人信息
    selPersonal() {
      this.$post('/institutionUser/queryInfo', { sysUserId: localStorage.getItem('sysUserId') },0,false).then(res => {
        const {department,basicInfo} = res
        if(department.path){
            department.isLeader = false
            let departmentPath=[]
            for(let m of department.path.split('/')){
              if(m&&m.length>0){
                departmentPath.push(m)
              }
            }
            if(departmentPath.length>1){
              department.isLeader = true
            }
        }
        this.$store.state.basicInfo = basicInfo
        this.$store.state.sysUserId = basicInfo.sysUserId
        this.$store.state.department = department
        this.$store.state.institutionUserId = basicInfo.id
        this.$store.state.listUserRole = basicInfo.listUserRole
      }).catch(err => {
        this.$Message.error(err.message);
      });
    },
    // 初始化语种
    cshLanguage: function() {
      // 如果没有设置过语种则默认为英文
      if (!localStorage.getItem('languageType')) {
        localStorage.setItem('languageType', 1);
      }
      this.$language(localStorage.getItem('languageType'), 1);
      
    },
    // 初始化后台维护系统数值
    cshHou: function() {
      // 查询科目
      this.selKemu();
      this.selBumen()
      // 查询系统数值
      for (var i = 1; i <= 13; i++) {
        // 标化考试放到了前端处理
        if (i != 6) {
          this.selXitong(i);
        }
      }
    },
    //查询所有角色
    selRoles() {
      // (url, params = {}, type = 0, isLoad = true,method = 'post')
      this.$post('/common/listAllRole', {}, 0, false, 'get')
        .then((res) => {
          var showHelp = {};
          for (var m of res) {
            m.id = String(m.roleId);
            m.showText = m.roleName;
            showHelp[m.roleId] = m.showText;
          }
          this.$store.state.userRole = res;
          this.$store.state.userRoleHelp = showHelp;
          this.panduan()
        })
        .catch((err) => {
          this.panduan()
        });
    },
    // 查询系统数值(1工作办公室,2所属顾问组,3所属校区,4职称,5产品名称,6标化考试名称,7是区号,8是服务包,)
    // url, params = {}, type = 0, isLoad = true,method = 'post'
    selXitong: function(i) {
      this.$post('/common/getSysValue', { parentId: 0, type: i }, 1, false ,'get').then(res => {
          var showHelp = {};
          for (var m of res) {
            if (i != 3) {
              m.id = String(m.id);
            }
            if (localStorage.getItem('languageType') == 0) {
              if (m.zhContent) {
                m.showText = m.zhContent;
              } else {
                m.showText = m.enContent;
              }
            } else if (localStorage.getItem('languageType') == 1) {
              m.showText = m.enContent;
            }
            showHelp[m.id] = m.showText;
          }
          switch (i) {
            case 1:
              this.$store.state.gongzuo = res;
              this.$store.state.gongzuoHelp = showHelp;
              break;
            case 2:
              this.$store.state.guwen = res;
              this.$store.state.guwenHelp = showHelp;
              break;
            case 3:
              this.$store.state.school = res;
              this.$store.state.schoolHelp = showHelp;
              break;
            case 4:
              this.$store.state.zhicheng = res;
              this.$store.state.zhichengHelp = showHelp;
              break;
            case 5:
              this.$store.state.chanpin = res;
              this.$store.state.chanpinHelp = showHelp;
              break;
            case 6:
              this.$store.state.kaoshi = res;
              this.$store.state.kaoshiHelp = showHelp;
              break;
            case 7:
              this.$store.state.quhao = res;
              this.$store.state.quhaoHelp = showHelp;
              break;
            case 8:
              this.$store.state.fuwubao = res;
              this.$store.state.fuwubaoHelp = showHelp;
              break;
            case 9:
              this.$store.state.englishLevel = res;
              this.$store.state.englishLevelHelp = showHelp;
              break;
            case 10:
              this.$store.state.CEFRLevel = res;
              this.$store.state.CEFRLevelHelp = showHelp;
              break;
            case 11:
              this.$store.state.learningTarget = res;
              this.$store.state.learningTargetHelp = showHelp;
              break;
            case 12:
              this.$store.state.subjectLevel = res;
              this.$store.state.subjectLevelHelp = showHelp;
              break;
            case 13:
              this.$store.state.examBoard = res;
              this.$store.state.examBoardHelp = showHelp;
              break;
          }
          this.panduan();
        }).catch(err => {
          this.panduan();
        });
    },
    // 查询科目
    selKemu: function() {
      this.$post('/common/getCourseList', { parentId: 0, type: 0 }, 1).then(res => {
          var showHelp = {};
          this.$store.state.kemu = [];
          for (var m of res) {
            if(m.value){
              m.id = String(m.id);
              m.showText = m.value;
              showHelp[m.id] = m.showText;
              this.$store.state.kemu.push(m);
            }
          }
          this.$store.state.kemuHelp = showHelp;
          this.panduan();
        }).catch(err => {
          this.panduan();
        });
    },
    // 判断数据是否获取完成
    panduan: function() {
      this.getDataNum++;
      if (this.getDataNum == 13) {
        this.getDataOver = true;
      }
    },
    changeBumenData(treeList){
      for(let m of treeList){
        m.isLeader = false
        if(m.children.length>0){
          m.isLeader = true
          this.changeBumenData(m.children)
        }
      }
      return treeList
    },
    // 查询部门
    selBumen: function() {
      this.$post('/common/getDepartment', { parentId: 0, type: 2 }, 1, false, 'get').then(res => {
          var showHelp = {};
          if(res.length>0){
            for (var m of this.changeBumenData(res)) {
              m.isLeader = false
              m.id = String(m.id);
              m.showText = m.departmentName;
              showHelp[m.id] = m.showText;
            }

            this.$store.state.bumen = this.changeBumenData(res);
            this.$store.state.bumenHelp = showHelp;
            this.panduan();
          }
        }).catch(err => {
          this.panduan();
        });
    },
    // 初始化前端维护系统数值
    cshQian: function() {
      for (var i in this.$systemValue) {
        
        var showHelp = {};
        for (var m of this.$systemValue[i]) {
          m.id = String(m.id);
          if (localStorage.getItem('languageType') == 0) {
            m.showText = m.ch;
          } else if (localStorage.getItem('languageType') == 1) {
            m.showText = m.en;
          }
          showHelp[m.id] = m.showText;
          // 如果是角色值,初始化对应角色的权限值
          // if(i == 'userRole'){
          //   this.$store.state.userRolePower[m.id] = m.power;
          // }
        }
        this.$store.state[i] = this.$systemValue[i];
        this.$store.state[i + 'Help'] = showHelp;
      }
    },
    // 判断滚动条宽度
    getGun: function(){
      var odiv = document.createElement('div'),//创建一个div
        styles = {
          width: '100px',
          height: '100px',
          overflowY: 'scroll'//让他有滚动条
        }, i, scrollbarWidth;
        for (i in styles) odiv.style[i] = styles[i];
        document.body.appendChild(odiv);//把div添加到body中
        scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
        odiv.remove();//移除创建的div
        this.$store.state.scrollbarWidth = scrollbarWidth;
    }
  },
  mounted() {
    let _this = this
    //根据页面地址区分BEconnect还是SG后台
    let url = window.location.href;
    if(url.indexOf('schoolsguide.com.cn')>-1){
      localStorage.setItem('isSp', 1);
      this.$store.state.isSp = 1;
    }else{
      localStorage.setItem('isSp', 0);
      this.$store.state.isSp = 0;
    }
    if(location.href.indexOf('?jytfFDJyrtdjy') > -1){
          let _this= this
          localStorage.clear()
          this.$store.state.isOBT = true; 
          this.$store.commit('SET_isOBT',true)
          window.addEventListener('message',function(msg){
            if(msg.data&&msg.data.lan){
              localStorage.setItem('languageObt',msg.data.lan)
              if(msg.data.lan=='en'){
                _this.$language(1,1)
              }else{
                _this.$language(0,1)
              }
            }else{
              localStorage.setItem('languageObt','en')
            }
          })
          let encodeUrl = location.href.split('?jytfFDJyrtdjy=')[1].replace(/-/g, "+").replace(/_/g, "/").replace(/%3D/g, "=").replace(/%2a/g,'*')
          let decodeUrl = Base64.decode(encodeUrl)//规则： customer_id（54） + *beit2022* + zohoUserId（0016F00003GnCapQAF）
          if(decodeUrl.indexOf('*beit2022*')>-1&&decodeUrl.split('*beit2022*')[0]&&decodeUrl.split('*beit2022*')[0]!='undefined'&&decodeUrl.split('*beit2022*')[0]!=undefined){
              let customerId = decodeUrl.split('*beit2022*')[0]
              let zohoUserId = decodeUrl.split('*beit2022*')[1]?decodeUrl.split('*beit2022*')[1]:''
              this.$store.state.customerId268 = customerId;
              this.$store.state.zohoUserId268 = zohoUserId;
              this.$store.commit('SET_CUSTOMER_ID268',customerId) 
              this.$store.commit('SET_ZOHO_ID268',zohoUserId) 
              this.getDataOver=true
        }else{
            this.$Message.success('Student account does not exist!')
        }
    }else{
      this.$store.state.isOBT = false;
      this.$store.commit('SET_isOBT',false) 
      // 初始化后台维护系统数值
      this.cshHou();
      //初始化角色
      this.selRoles()
    }
    // 初始化语种
    this.cshLanguage();
    // 判断滚动条宽度
    this.getGun();
    // 初始化前端维护系统数值
    this.cshQian();
    if(localStorage.getItem('sysUserId')){
      this.selPersonal();
    }
  },
  computed:{
    spinShow(){
      return this.$store.state.isGlobalSpin
    }
  }
};
</script>

<style>
body,
html {
  width: 100%;
  height: 100%;
  /* position: fixed;
  top: 0;
  left: 0; */
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  overflow: hidden;
  word-wrap: break-word;
  white-space: normal;
}

body,
div,
p,
span,
ul,
li,
iframe,
header,
footer,
a {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  display: block;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

#app.true{
  padding-top: 72px;
}

.scroll {
  overflow-y: scroll;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

div,
input,
textarea,
p,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

input {
  -webkit-appearance: none;
}

input:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
}

.one-line {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}

.two-line {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.canClick {
  cursor: pointer;
}

/* 隐藏滚动条 */
.outer-container,
.content {
  width: 100%;
  height: 100%;
}

.outer-container {
  position: relative;
  overflow: hidden;
}
.inner-container {
  position: absolute;
  left: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
}

/* POP提示 */
.ivu-poptip-rel{
  display: block;
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.ivu-spin-fix{
  background-color: rgba(255,255,255,.5);
}
</style>



// WEBPACK FOOTER //
// src/App.vue